import builder from '../builder';
import CalendarCheck from '../../streamline-icons/bold/calendar-check.svg';

export default builder('IconCalendarCheckBold', CalendarCheck);
